export default __webpack_public_path__ + "9bc35782c962669cf393668f16570bb5.jpg";